import FeaturePage from "../../components/FeaturePage";
import { Package, ScanBarcode, Building2, AlertTriangle, RefreshCw, ListTree } from "lucide-react";

export default function ManageInventory() {
  return (
    <FeaturePage
      badge="Manage Inventory"
      title="Inventory you can actually trust."
      highlight="Every count, accurate."
      subtitle="Generate barcodes, manage products, transfer stock across warehouses and locations, and never sell what you don't have. All in one place."
      heroImage="https://images.unsplash.com/photo-1763718528755-4bca23f82ac3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      heroBg="cream"
      features={[
        { icon: <Package size={22} />, title: "Unlimited products", desc: "Variants, bundles, kits, raw materials — model your catalog any way." },
        { icon: <ScanBarcode size={22} />, title: "Barcode generator", desc: "Generate, print, and scan barcodes from any device. SKU automation." },
        { icon: <Building2 size={22} />, title: "Multi-warehouse", desc: "Stock across unlimited warehouses with one-click transfers." },
        { icon: <AlertTriangle size={22} />, title: "Low-stock alerts", desc: "Get notified before you run out, by email, SMS, or in-app push." },
        { icon: <RefreshCw size={22} />, title: "Auto sync", desc: "Real-time sync across POS, online store, and integrations." },
        { icon: <ListTree size={22} />, title: "Categories & tags", desc: "Organize with infinite categories, tags, attributes, and collections." },
      ]}
      details={[
        {
          tag: "Stock control",
          title: "Know exactly what you have, where, and when.",
          desc: "Every move logged. Every transfer tracked. Every count reconciled. Brivo gives you a single source of truth across every location.",
          bullets: ["Real-time stock levels", "Stock transfer between warehouses", "Cycle counts and adjustments"],
        },
        {
          tag: "Barcodes",
          title: "From box to shelf in 4 seconds.",
          desc: "Auto-generate barcodes for every product, print sheets in bulk, and scan with your phone camera. No expensive scanner hardware required.",
          bullets: ["Print 30-up label sheets", "Mobile camera scanning", "Custom SKU formats"],
        },
        {
          tag: "Forecasting",
          title: "Buy smarter, not more.",
          desc: "Brivo learns your sales velocity and tells you when to reorder, how much, and from whom — so you never over-buy again.",
        },
      ]}
      useCases={[
        { title: "Retail stores", desc: "Multi-location stock with mobile counting." },
        { title: "Wholesale", desc: "Pallets, units, cases — track every level cleanly." },
        { title: "Manufacturing", desc: "Raw materials, BOMs and finished goods." },
        { title: "Online sellers", desc: "Sync with Shopify, WooCommerce and more." },
      ]}
      ctaTitle="Inventory chaos? Solved."
      ctaSubtitle="Get a single source of truth across every product, location and channel."
      ctaAccent="mint"
    />
  );
}
